import styled from 'styled-components';

const TotalResultsWrapper = styled.div`
  flex: 0 0 auto;
  height: 71px;
  width: 100%;
  display: flex;
  background-color: #eceeef;
  justify-content: ${({ centered }) => (centered ? 'center' : 'flex-end')};
  align-items: center;
`;

export default TotalResultsWrapper;
